export default __webpack_public_path__ + "static/media/mbank.64461691.png";